export default "__VITE_ASSET__e555d6c9__"